import { Element, h } from './element';
import { bindClickoutside, unbindClickoutside } from './event';
import { cssPrefix } from '../config';

export default class Dropdown extends Element {
  constructor(title, width, showArrow, placement, ...children) {
    super('div', `${cssPrefix}-dropdown ${placement}`);
    this.title = title;
    this.change = () => {};
    this.headerClick = () => {};
    if (typeof title === 'string') {
      this.title = h('div', `${cssPrefix}-dropdown-title`).child(title);
    } else if (showArrow) {
      this.title.addClass('arrow-left');
    }
    this.contentEl = h('div', `${cssPrefix}-dropdown-content`)
      .css('width', width)
      .hide();

    this.setContentChildren(...children);

    this.headerEl = h('div', `${cssPrefix}-dropdown-header`);
    this.headerEl.on('click', () => {
      if (this.contentEl.css('display') !== 'block') {
        this.show();
      } else {
        this.hide();
      }
    }).children(
      this.title,
      showArrow ? h('div', `${cssPrefix}-icon arrow-right`).child(
        h('div', `${cssPrefix}-icon-img arrow-down`),
      ) : '',
    );
    this.children(this.headerEl, this.contentEl);
  }

  setContentChildren(...children) {
    this.contentEl.html('');
    if (children.length > 0) {
      this.contentEl.children(...children);
    }
  }

  setTitle(title) {
    this.title.html(title);
    this.hide();
  }

  show() {
    const { contentEl } = this;
    contentEl.show();
    this.parent().active();
    bindClickoutside(this.parent(), () => {
      this.hide();
    });
  }

  hide() {
    this.parent().active(false);
    this.contentEl.hide();
    unbindClickoutside(this.parent());
  }

  //获取菜单每一项的offset
  getMenuItemOffset(type){
    const { el } = this;
    let { top, left, height, width } = this.contentEl.offset();
    const { topScroll, leftScroll } = this.contentEl.scroll();
    
    console.log("el.scroll()......",this.contentEl.scroll());
    console.log("el.offset()......",this.contentEl.offset());
    console.log("el.offset()......",this.contentEl.el);
    console.log("MenuItem type......",type);
    let menuItem =  null;
    if (this.contentEl.el && this.contentEl.el.children) {
      let array = Array.from(this.contentEl.el.children)
      array.forEach(element => {
        if (element && element.classList && element.classList.contains(type)) {
          menuItem = element;
        }
      });
    }
    console.log("menuItem222......",menuItem);
    console.log("menuItem333......",{
      top:top+menuItem.offsetTop-this.contentEl.scroll().top,
      left:left+menuItem.offsetLeft,
      width:menuItem.offsetWidth,
      height:menuItem.offsetHeight,
    });
    return {
      top:top+menuItem.offsetTop-this.contentEl.scroll().top,
      left:left+menuItem.offsetLeft,
      width:menuItem.offsetWidth,
      height:menuItem.offsetHeight,
    }
  }
}
